import { Pipe, PipeTransform } from '@angular/core';
import { highlightSettingsSearch } from './settings.search';

@Pipe({ name: 'settingsSearchHighlight', standalone: true, pure: true })
export class SettingsSearchHighlightPipe implements PipeTransform {

  public transform(value: string | null | undefined, query: string | null | undefined): string {

    return highlightSettingsSearch(value ?? '', query ?? '');
  }
}
